import React from 'react';
import { CliError, CliErrorCode } from '@wix/cli-error';
import type { CommandServices } from '@wix/cli-command-contract';
import { PreviewCommand } from '../components/PreviewCommand/index.js';
import type { PreviewData } from '../components/PreviewCommand/index.js';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractivePreview(
  services: CommandServices,
  model: ProjectModel,
  options: { siteId?: string; baseUrl?: string }
) {
  const { baseUrl, siteId } = options;

  if (!siteId) {
    throw new CliError({
      code: CliErrorCode.SiteConfiguredRequired(),
      cause: null,
    });
  }

  const data = await executeCommand<PreviewData>(services, model, (resolve) => (
    <PreviewCommand
      baseUrl={baseUrl}
      siteIdOverride={siteId}
      onPreviewCreated={resolve}
    />
  ));

  log(JSON.stringify({ version: data.armTag }, null, 2));
}
